import { useEffect } from "react";

const UserInteractionDetection = ({ renewSessionTime }: { renewSessionTime: () => void }) => {
  useEffect(() => {
    const onUserInteracted = () => {
      renewSessionTime();
    };

    const onMessageFromIFrame = (event: MessageEvent) => {
      if (event.data.type !== "legacy-app:iframe-interacted") return;
      onUserInteracted();
    };

    document.addEventListener("click", onUserInteracted);
    document.addEventListener("input", onUserInteracted);
    window.addEventListener("message", onMessageFromIFrame);

    return () => {
      document.removeEventListener("click", onUserInteracted);
      document.removeEventListener("input", onUserInteracted);
      window.removeEventListener("message", onMessageFromIFrame);
    };
  }, [renewSessionTime]);

  return null;
};

export default UserInteractionDetection;
